import React, { useEffect } from "react";
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  message,
  Upload,
  Spin,
} from "antd";
import App from "../../Utils/LayoutMobile";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createUser, resetUserState } from "../../features/userSlice";

const CreateUser = () => {
  const [form] = Form.useForm();
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const { loading, success, error } = useSelector((state) => state.user);

  useEffect(() => {
    if (success) {
      message.success("User created successfully");
      form.resetFields();
      navigation("/Users");
    }
    if (error) {
      message.error(error);
    }
  }, [success, error, dispatch, navigation]);

  const handleSubmit = (values) => {
    const formData = new FormData();
    Object.keys(values).forEach((key) => {
      if (key === "image" && values[key]?.[0]?.originFileObj) {
        formData.append("image", values[key][0].originFileObj);
      } else {
        formData.append(key, values[key]);
      }
    });
    dispatch(createUser(formData));
  };

  // Image file validation: must be image and less than 3MB
  const beforeUpload = (file) => {
    const isImage = file.type.startsWith("image/");
    const isLt3M = file.size / 1024 / 1024 < 3;

    if (!isImage) {
      message.error("You can only upload image files!");
      return Upload.LIST_IGNORE;
    }

    if (!isLt3M) {
      message.error("Image must be smaller than 3MB!");
      return Upload.LIST_IGNORE;
    }

    return false; // prevent auto-upload
  };

  return (
    <App>
      <Spin spinning={loading}>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={{ status: false, role: "faculty" }}
        >
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <h2 style={{ marginBottom: 30 }}>Add User</h2>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item
                name="name"
                label="Full Name"
                rules={[{ required: true, message: "Please enter your full name" }]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  { type: "email", message: "Invalid email" },
                  { required: true, message: "Please enter your email" },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item name="role" initialValue="faculty" hidden>
                <Input />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                name="location"
                label="Location"
                rules={[{ required: true, message: "Please enter your location" }]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                name="image"
                label="Image"
                valuePropName="fileList"
                getValueFromEvent={(e) => e.fileList}
                rules={[
                  {
                    required: true,
                    message: "Please upload an image",
                  },
                ]}
              >
                <Upload
                  name="image"
                  listType="picture"
                  beforeUpload={beforeUpload}
                  maxCount={1}
                >
                  <Button>Select Image</Button>
                </Upload>
              </Form.Item>
            </Col>
          </Row>

          <Form.Item>
            <div>
              <Button
                type="primary"
                htmlType="submit"
                style={{ marginRight: 8 }}
              >
                Create Faculty
              </Button>

              <Button
                danger
                onClick={() => {
                  navigation("/Users");
                }}
              >
                Cancel
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Spin>
    </App>
  );
};

export default CreateUser;
